import { URL_GET_CONTACT_API } from 'constants/urls';

const getContactApi = async (id) => {
	const options = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	};
	const url = `${URL_GET_CONTACT_API}${id}`;
	const res = await fetch(url, options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	} else {
		const data = await res.json();
		return data;
	}
};

export default getContactApi;
